/**
 * 角色相关接口
 */
 import request from '../utils/axios'
 
 // 添加角色
 export function Add(params) {
   return request({
     url: `/Role/Add`,
     method: 'post',
		 data:params
   })
 }
 
 // 修改角色
 export function UpdateRole(params) {
   return request({
     url: `/Role/UpdateRole`,
     method: 'post',
 		 data:params
   })
 }
 
 // 获取角色下拉框
 export function GetRoleSelectionBox() {
   return request({
     url: `/Role/GetRoleSelectionBox`,
     method: 'get'
   })
 }
 
 // 获取角色列表
 export function GetRoleList(params) {
   return request({
     url: `/Role/GetRoleList`,
     method: 'post',
		 data:params
   })
 }

// 获取角色权限集合
export function GetRolePowers() {
  return request({
    url: `/Role/GetRolePowers`,
    method: 'get'
  })
}

// 删除角色（工作人员）
export function Delete(id) {
  return request({
    url: `/Role/Delete?id=${id}`,
    method: 'get'
  })
}